import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useAnalytics } from '../Analytics/Analytics';

const context = createContext<TooltipState>({} as TooltipState);

export const useTooltip = () => useContext(context);

export function TooltipProvider({ children }: TooltipProviderProps) {
    const [content, setContent] = useState<any>(null);
    const [open, setOpen] = useState(false);
    const [x, setX] = useState(0);
    const [y, setY] = useState(0);
    const analytics = useAnalytics();

    const handleKeyDown = useCallback((e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            setOpen(false);
        }
    }, []);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);

    function show(x: number, y: number, content: any) {
        // Set state
        setContent(content);
        setX(x);
        setY(y);
        setOpen(true);

        // Track event
        const title = content?.[0]?.props?.title;
        if (title) {
            analytics.trackEvent('tooltip', { title: content?.[0]?.props.title });
        }
    }

    const state = {
        content,
        open,
        x,
        y,
        hide: () => setOpen(false),
        show,
    };

    return <context.Provider value={state}>{children}</context.Provider>;
}
